import React from "react";
import { MonitorSmartphoneIcon, ShieldCheckIcon, CreditCardIcon } from "lucide-react";
import { PACK_IMAGE, packItems } from "../data/content";
import { offer } from "../data/offer";
import { CheckList } from "./CheckList";
import { CtaButton } from "./CtaButton";
import { PendingNote } from "./PendingNote";
import { SectionHeading } from "./SectionHeading";
import { trackPixelEvent } from "../utils/metaPixel";
export function OfferSection() {
  return <section id="offer-details" className="bg-forest-deep py-16 text-white md:py-24" data-id="element-177" data-mp="ifkrew20kv36">
      <div className="wrap" data-id="element-178" data-mp="md0fooy6gesb">
        <SectionHeading tone="dark" eyebrow="La oferta completa" title={<>
              Todo para mostrar mejor <span className="text-gold" data-id="element-180" data-mp="wbof06idu56o">tu emprendimiento</span>
            </>} data-id="element-179" data-mp="re66gh8a1rz7" />

        <div className="mx-auto mt-10 grid max-w-[1040px] overflow-hidden rounded-2xl border-2 border-gold bg-white text-ink shadow-[0_30px_80px_rgba(0,0,0,0.45)] md:mt-12 md:grid-cols-[0.9fr_1.1fr] md:rounded-3xl" data-id="element-181" data-mp="2t6kuly1ezso2">
          <div className="flex flex-col items-center justify-center bg-night px-8 py-6 md:py-10" data-id="element-182" data-mp="12otg7ix4xfjj">
            <img src={PACK_IMAGE} alt="Pack Tu iPhone, Tu Estudio: libro principal y cinco bonos" width={1024} height={1536} loading="lazy" className="block h-auto w-full max-w-[220px] md:max-w-[360px]" data-id="element-183" data-mp="xvh4289n717o" />
          </div>

          <div className="p-5 md:p-10" data-id="element-184" data-mp="1lk0asjd1n5xn">
            <span className="inline-block rounded-full bg-gold-cream px-3 py-1 text-[11px] font-bold uppercase tracking-[2px] text-[#164BBB]" data-id="element-185" data-mp="1gn1js9ooff3o">
              Libro principal + 5 bonos
            </span>
            <h3 className="display-title mt-4 text-[clamp(36px,4vw,48px)]" data-id="element-186" data-mp="17ljtxzlgvz1s">{offer.packageName}</h3>
            <p className="mt-3 text-muted" data-id="element-187" data-mp="17kjytezxnrp">
              La guía de cámara para fotografiar y grabar tu emprendimiento, más cinco recursos para armar tu
              miniestudio, generar ideas, aparecer en cámara, ordenar tu catálogo y escribir tus textos.
            </p>

            <div className="mt-6" data-id="element-188" data-mp="2ng7k22elacp">
              <CheckList items={packItems} data-id="element-189" data-mp="2mdjs30dno10" />
            </div>

            <div className="mt-8 border-t border-line pt-6 text-center" data-id="element-190" data-mp="3ktl24wa4ubed">
              {offer.price ? <>
                  {offer.previousPrice && <p className="text-muted" data-id="element-191" data-mp="3owr802tc20kb">
                      Antes <s data-id="element-192" data-mp="3b2gnjxodcsk2">{offer.previousPrice}</s>
                      {offer.savings && <span className="ml-2 rounded bg-cta/10 px-2 py-0.5 text-sm font-bold text-cta-shadow" data-id="element-193" data-mp="3fv9u8r3eeays">
                          Ahorrás {offer.savings}
                        </span>}
                    </p>}
                  <p className="display-title mt-1 text-[clamp(56px,7vw,76px)] text-ink" data-id="element-194" data-mp="2s4nm6zte8qos">{offer.price}</p>
                  {offer.paymentTerms && <p className="text-sm font-bold uppercase tracking-[1.5px] text-ink" data-id="element-195" data-mp="2x2ff9x5ryiuk">{offer.paymentTerms}</p>}
                  {offer.priceNote && <p className="mt-2 text-sm text-muted" data-id="element-196" data-mp="28iu7nqpjdlk5">{offer.priceNote}</p>}
                </> : <PendingNote data-id="element-197" data-mp="2mj4y4smxoy4s">precio final, moneda y modalidad de pago.</PendingNote>}
            </div>

            <div className="mt-6" data-id="element-198" data-mp="2ifytfpfgzf0f">
              <CtaButton href={offer.checkoutUrl} fullWidth onClick={() => trackPixelEvent("InitiateCheckout", {
              content_name: offer.packageName
            })} data-id="element-199" data-mp="2ij4jp7zu4mxq">
                Comprar ahora
              </CtaButton>
              {!offer.checkoutUrl && <div className="mt-3" data-id="element-200" data-mp="368fco3ay1d1b">
                  <PendingNote data-id="element-201" data-mp="3179h7xpwfbo3">link de checkout.</PendingNote>
                </div>}
            </div>

            <ul className="mt-6 list-none space-y-3 p-0 text-sm text-muted" data-id="element-202" data-mp="3f8c3aagw8lz0">
              <li className="flex items-start gap-2.5" data-id="element-203" data-mp="3a8pqg24z97qq">
                <MonitorSmartphoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-204" data-mp="3a64qjio8p1vm" />
                <span data-id="element-205" data-mp="18h7fn549m7gl">
                  Material digital en español para leer desde tu teléfono, tablet o computadora.
                  {offer.delivery && ` ${offer.delivery}`}
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-206" data-mp="1ma6ud4w83xn3">
                <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-207" data-mp="1m9nc1n2nv78j" />
                <span data-id="element-208" data-mp="pm90o4bv60hd">
                  {offer.guarantee ? `${offer.guarantee.title}: si no te gusta o no te sirve, te devolvemos el dinero.` : "Garantía: pendiente de confirmar."}
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-209" data-mp="13l07r6sb6lw0">
                <CreditCardIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-210" data-mp="2a017lnkgfo7v" />
                <span data-id="element-211" data-mp="2eyubco9xw0uu">
                  {[offer.paymentTerms, ...offer.paymentMethods, "pagás en tu moneda local"].filter(Boolean).join(" · ")}
                </span>
              </li>
            </ul>
            {!offer.delivery && <div className="mt-4" data-id="element-212" data-mp="2k6aj7170e54w">
                <PendingNote data-id="element-213" data-mp="2fcg307qm48ak">cómo se entrega el material y cuánto dura el acceso.</PendingNote>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}